import React from 'react';
import Icon from '../../../components/AppIcon';

const FilterSection = ({ 
  selectedTopic, 
  setSelectedTopic, 
  selectedFormat, 
  setSelectedFormat, 
  selectedIndustry, 
  setSelectedIndustry 
}) => {
  const topics = [
    { id: 'all', name: 'All Topics', icon: 'Grid3X3' },
    { id: 'governance', name: 'Data Governance', icon: 'Shield' },
    { id: 'analytics', name: 'Analytics Strategy', icon: 'TrendingUp' },
    { id: 'compliance', name: 'Compliance', icon: 'FileCheck' },
    { id: 'team', name: 'Team Development', icon: 'Users' },
    { id: 'ai', name: 'AI & Machine Learning', icon: 'Brain' },
    { id: 'cloud', name: 'Cloud Migration', icon: 'Cloud' }
  ];

  const formats = [
    { id: 'all', name: 'All Formats', icon: 'LayoutGrid' },
    { id: 'articles', name: 'Articles', icon: 'FileText' },
    { id: 'frameworks', name: 'Frameworks', icon: 'Layers' },
    { id: 'tools', name: 'Tools', icon: 'Wrench' },
    { id: 'webinars', name: 'Webinars', icon: 'Video' },
    { id: 'templates', name: 'Templates', icon: 'Download' }
  ];

  const industries = [
    { id: 'all', name: 'All Industries', icon: 'Building' },
    { id: 'finance', name: 'Financial Services', icon: 'Banknote' },
    { id: 'healthcare', name: 'Healthcare', icon: 'Heart' },
    { id: 'retail', name: 'Retail & E-commerce', icon: 'ShoppingCart' },
    { id: 'manufacturing', name: 'Manufacturing', icon: 'Factory' },
    { id: 'technology', name: 'Technology', icon: 'Cpu' }
  ];

  const FilterGroup = ({ title, items, selected, onSelect, icon }) => (
    <div className="space-y-3">
      <div className="flex items-center space-x-2">
        <Icon name={icon} size={16} className="text-primary" />
        <h3 className="font-semibold text-primary text-sm">{title}</h3>
      </div>
      <div className="flex flex-wrap gap-2">
        {items?.map((item) => (
          <button
            key={item?.id}
            onClick={() => onSelect(item?.id)}
            className={`flex items-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-300 hover:scale-105 active:scale-95 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 ${
              selected === item?.id
                ? 'bg-primary text-white shadow-md'
                : 'bg-white text-muted-foreground hover:bg-surface hover:text-primary border border-border hover:border-primary hover:shadow-sm'
            }`}
          >
            <Icon name={item?.icon} size={14} />
            <span>{item?.name}</span>
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <section className="bg-surface py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-xl p-6 lg:p-8 shadow-subtle">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-semibold text-primary">Filter Resources</h2>
            <button
              onClick={() => {
                setSelectedTopic('all');
                setSelectedFormat('all');
                setSelectedIndustry('all');
              }}
              className="flex items-center space-x-2 text-sm text-muted-foreground hover:text-primary hover:scale-105 active:scale-95 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
            >
              <Icon name="RotateCcw" size={16} />
              <span>Clear All</span>
            </button>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <FilterGroup
              title="Topics"
              icon="Tag"
              items={topics}
              selected={selectedTopic}
              onSelect={setSelectedTopic}
            />
            <FilterGroup
              title="Format"
              icon="Filter"
              items={formats}
              selected={selectedFormat}
              onSelect={setSelectedFormat}
            />
            <FilterGroup
              title="Industry"
              icon="Building2"
              items={industries}
              selected={selectedIndustry}
              onSelect={setSelectedIndustry}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FilterSection;